/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ annual_plan_monthly_price: NonNullable<unknown>, annual_plan_price: NonNullable<unknown> }} New_User_Paywall_Footer_Free_VerInputs */

const en_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Totally free for 7 days, then ${i?.annual_plan_monthly_price} /month, billed annually at ${i?.annual_plan_price}. Cancel anytime.`)
};

const ar_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مجاني تمامًا لمدة 7 أيام، ثم ${i?.annual_plan_monthly_price} شهريًا، يُدفع سنويًا بقيمة ${i?.annual_plan_price}. يمكنك الإلغاء في أي وقت`)
};

const de_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`7 Tage lang kostenlos, danach ${i?.annual_plan_monthly_price} /Monat, jährliche Abrechnung unter ${i?.annual_plan_price}. Jederzeit kündbar.`)
};

const es_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Totalmente gratis durante 7 días, luego ${i?.annual_plan_monthly_price} /, mes, facturado anualmente a ${i?.annual_plan_price}. Cancela en cualquier momento.`)
};

const fr_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`7 jours d'essai gratuit, puis ${i?.annual_plan_monthly_price}/mois (facturation annuelle de ${i?.annual_plan_price}). Résiliez quand vous voulez.`)
};

const it_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Completamente gratuito per 7 giorni, poi ${i?.annual_plan_monthly_price}/mese, fatturato annualmente a ${i?.annual_plan_price}. Annulla in qualsiasi momento`)
};

const ja_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`7日間は完全無料、その後は年額${i?.annual_plan_price}（${i?.annual_plan_monthly_price}/月）請求されます。いつでもキャンセル可能です。`)
};

const ko_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`7일간 완전히 무료이며 이후에는 ${i?.annual_plan_monthly_price}/월, 연간 요금은 ${i?.annual_plan_price}씩 청구됩니다. 언제든지 취소할 수 있습니다`)
};

const pt_br_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inteiramente grátis por 7 dias, depois ${i?.annual_plan_monthly_price}/mês, cobrado anualmente a ${i?.annual_plan_price}. Cancele quando quiser.`)
};

const ru_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Абсолютно бесплатно в течение 7 дней, затем ${i?.annual_plan_monthly_price}/месяц, оплата за год составляет ${i?.annual_plan_price}. Отмена в любое время`)
};

const th_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ทดลองใช้ฟรี 7 วันเต็ม หลังจากนั้น ${i?.annual_plan_monthly_price} /เดือน โดยเรียกเก็บเงินเป็นรายปี ${i?.annual_plan_price} ยกเลิกได้ทุกเมื่อ`)
};

const tr_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`7 gün boyunca tamamen ücretsiz, ardından aylık ${i?.annual_plan_monthly_price}, yıllık ${i?.annual_plan_price} karşılığında faturalandırılır. İstediğin zaman iptal edebilirsin.`)
};

const zh_cn_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`前 7 天完全免费，之后按年计费则每月${i?.annual_plan_monthly_price}，每年 ${i?.annual_plan_price}。可随时取消。`)
};

const zh_tw_new_user_paywall_footer_free_ver = /** @type {(inputs: New_User_Paywall_Footer_Free_VerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`前 7 天完全免費，之後按年計費則每月${i?.annual_plan_monthly_price}，每年 ${i?.annual_plan_price}。可隨時取消。`)
};

/**
* | output |
* | --- |
* | "Totally free for 7 days, then {annual_plan_monthly_price} /month, billed annually at {annual_plan_price}. Cancel anytime." |
*
* @param {New_User_Paywall_Footer_Free_VerInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const new_user_paywall_footer_free_ver = /** @type {((inputs: New_User_Paywall_Footer_Free_VerInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_User_Paywall_Footer_Free_VerInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_user_paywall_footer_free_ver(inputs)
	if (locale === "ar") return ar_new_user_paywall_footer_free_ver(inputs)
	if (locale === "de") return de_new_user_paywall_footer_free_ver(inputs)
	if (locale === "es") return es_new_user_paywall_footer_free_ver(inputs)
	if (locale === "fr") return fr_new_user_paywall_footer_free_ver(inputs)
	if (locale === "it") return it_new_user_paywall_footer_free_ver(inputs)
	if (locale === "ja") return ja_new_user_paywall_footer_free_ver(inputs)
	if (locale === "ko") return ko_new_user_paywall_footer_free_ver(inputs)
	if (locale === "pt_br") return pt_br_new_user_paywall_footer_free_ver(inputs)
	if (locale === "ru") return ru_new_user_paywall_footer_free_ver(inputs)
	if (locale === "th") return th_new_user_paywall_footer_free_ver(inputs)
	if (locale === "tr") return tr_new_user_paywall_footer_free_ver(inputs)
	if (locale === "zh_cn") return zh_cn_new_user_paywall_footer_free_ver(inputs)
	return zh_tw_new_user_paywall_footer_free_ver(inputs)
});